import { useQuery } from '@tanstack/react-query';
import { getPushConfig } from '../lib/apiClient';

// Config for a whole deploy, effectively static between deploys.
const STALE_TIME_MS = 10 * 60_000;

export function usePushConfig() {
  return useQuery({
    queryKey: ['push-config'],
    queryFn: getPushConfig,
    staleTime: STALE_TIME_MS,
  });
}
